import $ from 'jquery'

export default {
    init() {
        let $scrollLock = $('.scroll-lock')

        // console.log('run')

        if ($scrollLock.length) {
            this.lock()

            window.addEventListener('scroll', e => {
                this.lock()
            })

            window.addEventListener('resize', e => {
                this.lock()
            })
        }
    },
    lock(scrollToTop) {
        let $scrollLock = $('.scroll-lock')
        if (scrollToTop) {
            function scrollToElement(scrollEl, speed = 800) {
                let appBarHeight = $('.app-bar').outerHeight()

                $('html, body').animate({
                    scrollTop: $scrollLock.offset().top - appBarHeight
                }, 500)
            }

            scrollToElement()
        }

        let fullscreenLock = () => {
            let appBarHeight = $('.app-bar').outerHeight()
            // let appBarHeight = 0

            $scrollLock.each((index, el) => {
                let $scrollLock = $(el)
                let scrollLockBounding = $scrollLock[0].getBoundingClientRect()
                let $scrollLockFixed = $scrollLock.find('.scroll-lock__lock')
                let scrollLockFixedBounding = $scrollLockFixed[0].getBoundingClientRect()
                let $scrollLockFixedInner = $scrollLock.find('.scroll-lock__lock-inner')
                let scrollLockFixedInnerBounding = $scrollLockFixedInner[0].getBoundingClientRect()
                let $content = $scrollLock.find('.scroll-lock__content')
                let $scrollLockWidthHelper = $scrollLock.find('.scroll-lock__width')
                let contentBounding = $content[0].getBoundingClientRect()
                let height = $scrollLockFixed.hasClass('scroll-lock__lock--start') ? window.innerHeight : window.innerHeight - appBarHeight
                height = $content.innerHeight() < height ? $content.innerHeight() : height;
                let top = $scrollLockFixed.hasClass('scroll-lock__lock--start') ? 0 : appBarHeight
                let enableOnThisWindowWidth = 1024

                // console.log(height)
                // console.log($scrollLock.outerHeight())
                // console.log($scrollLock.scrollTop())
                // console.log({scrollLockBounding})
                // console.log({scrollLockFixedBounding})
                // console.log({scrollLockFixedInnerBounding})

                // console.log(contentBounding)
                // console.log(window.innerHeight)
                // console.log($scrollLockFixed)
                // console.log($scrollLockWidthHelper[0].getBoundingClientRect())
                // console.log($(window).width())

                $scrollLockFixed.css({
                    'width': `${$scrollLockWidthHelper.width()}px`,
                    // 'height': `${height}px`,
                })

                if (enableOnThisWindowWidth >= $(window).width()) {
                    $scrollLockFixed.css({
                        'top': ``,
                        'position': '',
                        'height': ``,
                        'background-position-y': ''
                    })

                    return;
                }

                // $scrollLockFixed.css({
                //     'top': `${top}px`,
                //     'position': 'fixed',
                //     // 'width': `${$scrollLockWidthHelper.width()}px`,
                //     'height': `${height}px`,
                //     'background-position-y': 'top'
                // })

                if (scrollLockBounding.top - appBarHeight < 0) {
                    $scrollLockFixed.css({
                        // 'top': `${top}px`,
                        'position': 'fixed',
                        // 'width': `${$scrollLockWidthHelper.width()}px`,
                        'height': `${height}px`,
                        'background-position-y': 'top'
                    })

                    let isScrollLockAtBottom = false;
                    if (window.innerHeight >= scrollLockBounding.bottom) {
                        isScrollLockAtBottom = true;
                    }

                    // // console.log({isScrollLockAtBottom})
                    // // console.log({diff})
                    // let scrollLockBoundingPos = scrollLockBounding.bottom;
                    // let scrollLockFixedInnerBoundingPos = scrollLockFixedInnerBounding.bottom;
                    // // scrollLockFixedInnerBoundingPos = scrollLockFixedInnerBoundingPos - parseInt($scrollLockFixed.css('margin-top'));
                    // // console.log({scrollLockBoundingPos})
                    // // console.log({scrollLockFixedInnerBoundingPos})

                    if (isScrollLockAtBottom) { //   && scrollLockBoundingPos <= scrollLockFixedInnerBoundingPos
                        // if(scrollLockBoundingPos <= scrollLockFixedInnerBoundingPos ) {
                        let scrollFixedTop = scrollLockFixedInnerBounding.top - (scrollLockFixedInnerBounding.bottom - scrollLockBounding.bottom)
                        // let scrollFixedTop = (scrollLockBoundingPos - scrollLockFixedInnerBoundingPos)
                        scrollFixedTop = scrollFixedTop - parseInt($scrollLockFixed.css('margin-top'));
                        // scrollFixedTop = top - (scrollLockFixedInnerBounding.top - scrollLockFixedInnerBoundingPos) ;
                        // console.log({top})
                        // console.log({scrollFixedTop})

                        // let diff = window.innerHeight - (scrollLockBounding.bottom);
                        // diff = window.innerHeight - diff - top;

                        let scrollLockRemainingBottomScroll = window.innerHeight - (scrollLockBounding.bottom);
                        let diff = window.innerHeight - scrollLockRemainingBottomScroll - top;
                        // let diff =  - (scrollLockBounding.bottom) - top;
                        // let diff = (scrollLockBounding.bottom - window.innerHeight );
                        // diff = window.innerHeight - diff - top;
                        //     console.log(window.innerHeight - diff - top)

                        if ((diff) <= scrollLockFixedInnerBounding.height) {
                            scrollFixedTop = top - (top - scrollFixedTop)
                            // scrollFixedTop = parseInt($scrollLockFixed.css('top'));
                        } else {
                            scrollFixedTop = top
                        }

                        $scrollLockFixed.css({
                            'top': `${scrollFixedTop}px`,
                        })

                        // return;
                        // }
                    } else {
                        $scrollLockFixed.css({
                            'top': `${top}px`,
                            // 'position': 'fixed',
                            // // 'width': `${$scrollLockWidthHelper.width()}px`,
                            // // 'height': `${height}px`,
                            // 'background-position-y': 'top'
                        })
                    }

                } else {
                    $scrollLockFixed.css({
                        'position': 'absolute',
                        'top': '0',
                        'bottom': 'auto',
                        'width': `${$scrollLockWidthHelper.width()}px`,
                        'height': `${height}px`,
                        // 'height': `auto`,
                    })
                }

            })
        }
        fullscreenLock()
    }
}

